import { render, staticRenderFns } from "./k-download-btn.vue?vue&type=template&id=114e45a0&scoped=true"
import script from "./k-download-btn.vue?vue&type=script&lang=js"
export * from "./k-download-btn.vue?vue&type=script&lang=js"
import style0 from "./k-download-btn.vue?vue&type=style&index=0&id=114e45a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114e45a0",
  null
  
)

export default component.exports